import { render } from "./ParentPortal.vue?vue&type=template&id=7109849d&scoped=true"
import script from "./ParentPortal.vue?vue&type=script&lang=js"
export * from "./ParentPortal.vue?vue&type=script&lang=js"

import "./ParentPortal.vue?vue&type=style&index=0&id=7109849d&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/SIMI-TRAC/SIMI-TRAC-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7109849d"]])

export default __exports__